<template>
  <div v-if="info.title" class="contract-fill-item">
    <div class="contract-sub-title">{{ info.title }}</div>
    <input
      v-if="!isStartGenerate"
      v-model.trim="info.content"
      class="input fill-input"
      type="text"
    >
    <div
      v-else
      class="input fill-input"
    >
      {{ info.content || '&nbsp;' }}
    </div>
  </div>
</template>

<script>
import { validatePhone, validateIdCard } from '@/utils/validate'
import { getTerminalInfo } from '@/utils/platformInfo'
import { Message } from 'element-ui'
import { Toast } from 'vant'
export default {
  name: 'ContractFill',

  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isStartGenerate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getSubmitData() {
      const keyMap = {
        '微信号': 'partyBWx',
        '身份证号码': 'partyBCardNumber',
        '乙方': 'partyBName',
        '联系方式': 'partyBPhone',
        '甲方': 'partyAName',
        '微信昵称': 'partyBWxName',
      }
      // 填写的信息
      const toastInfo = {
        // 乙方身份证号
        partyBCardNumber: '请输入身份证号',
        // 乙方姓名
        partyBName: '请输入姓名',
        // 甲方姓名
        partyAName: '请输入姓名',
        // 乙方手机号
        partyBPhone: '请输入手机号',
        // 乙方签名
        partyBSignature: '请点击确认签名',
        // 乙方微信号
        partyBWx: '请输入微信号'
      }
      const { title, isRequire } = this.info
      const curentKey = keyMap[title]
      if(!curentKey) {
        return {}
      }
      if(!isRequire) {
        if(curentKey === 'partyBPhone') {
          if (this.info.content && !validatePhone(this.info.content)) {
            this.toast('请输入合法的手机号码')
            return false
          }
        }
        if(curentKey === 'partyBCardNumber') {
          if (this.info.content && !validateIdCard(this.info.content)) {
            this.toast('请输入合法的身份证')
            return false
          }
        }
        return { [curentKey]: this.info.content }
      }
      if(!this.info.content) {
      this.toast(toastInfo[curentKey])
        return false
      }
      if(curentKey === 'partyBPhone') {
        if (!validatePhone(this.info.content)) {
          this.toast('请输入合法的手机号码')
          return false
        }
      }
      if(curentKey === 'partyBCardNumber') {
        if (!validateIdCard(this.info.content)) {
          this.toast('请输入合法的身份证')
          return false
        }
      }
      console.log(curentKey)
      return {
        [curentKey]: this.info.content
      }
    },
    toast(msg, type = 'error') {
      const isMobile = getTerminalInfo() === 'mobile'
      if (isMobile) {
        Toast({
          message: msg,
          position: 'bottom'
        })
      } else {
        Message[type](msg)
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.contract-fill-item {
  margin-top 30px
  .fill-input {
    width: 240px
    border: none
    border-bottom: 1px solid #000
    font-size 16px
    padding 4px 0
  }
}
.contract-sub-title {
  font-size: 16px
  font-weight: bold
}
</style>
